/**
 * Analysis page — the iframe is persistently mounted at the App level
 * via AnalysisIframe. This component renders the ModuleSlider for navigation.
 */
import ModuleSlider from '../components/map/ModuleSlider';

function Analysis() {
  return (
    <>
      {/* Module Slider - Navigation between modules */}
      <ModuleSlider
        showNavbarControls={false}
        setShowNavbarControls={() => {}}
        showSimfixAreas={false}
        setShowSimfixAreas={() => {}}
        showPredictMode={false}
        setShowPredictMode={() => {}}
        showTlGreenWave={false}
        setShowTlGreenWave={() => {}}
        showAssignx={false}
        setShowAssignx={() => {}}
      />
    </>
  );
}

export default Analysis;
